module.exports = "../../app/cells/pages/disciplines/cta_discipline_list_cell.rb";